
const API_BASE_URL = 'https://backend.securenetindia.com';

export default API_BASE_URL;